import React from "react";
import { LoadingSpinner } from "./icons/LoadingSpinner";

interface QueryInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export const QueryInput: React.FC<QueryInputProps> = ({
  value,
  onChange,
  onSubmit,
  isLoading,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
      <label
        htmlFor="query"
        className="block text-sm font-medium text-slate-600 mb-2"
      >
        Ask a question about the survey data
      </label>
      <textarea
        id="query"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder="e.g., 'Compare approval vs rejection rate by district'"
        className="w-full h-32 p-2 bg-gray-50 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-colors duration-200 resize-none"
        disabled={isLoading}
      />
      <button
        onClick={onSubmit}
        disabled={isLoading || !value.trim()}
        className="mt-4 w-full flex items-center justify-center bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded-md transition-colors duration-200"
      >
        {isLoading ? <LoadingSpinner /> : "Generate Visualization"}
      </button>
    </div>
  );
};
